import React from "react";
import seat from "../assets/images/seat.png";

const CarItem = (car) => {
const { name,seats,suitcase,text,image } = car.car
  return (
    <div className="car-item flex flex-col md:flex-row justify-center items-center gap-10 mb-10 last:mb-0">
      <div className="w-full md:w-1/2 ">
        <img src={image} alt={name} className="w-full md:w-3/4 ml-auto" />
      </div>
      <div className="w-full md:w-1/2 flex flex-col">
        <p className="text-3xl">{name}</p>
        <p className="text-lg mt-5">
          <span className="mr-3">
            <img src={seat} alt="seat" className="w-5 inline-block" /> seats: {seats}
          </span>
          <span>
            <i class="fa-solid fa-suitcase"></i> Suitcase: {suitcase}
          </span>
        </p>
        <p className="text-lg mt-5">
          {text}
        </p>
        <button className="btn bg-violet-600 hover:scale-110 transition duration-200 text-slate-100 rounded-full inline-block w-32 h-10 mt-10 mx-auto md:mx-0">
          Book now
        </button>
      </div>
    </div>
  );
};

export default CarItem;
